var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTornLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.67,
    height: 78.297,
    viewBox: "0 0 85.67 78.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 85.67,
    height: 78.297,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 85.668,
    height: 62.705,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6098",
    "data-name": "Group 6098",
    transform: "translate(-448.763 -763.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6961",
    "data-name": "Path 6961",
    d: "M468.667,808.725l13.974-7.784-.007-27.775-12.929,7.2Z",
    transform: "translate(8.159 3.843)",
    fill: "#c7c5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6962",
    "data-name": "Path 6962",
    d: "M468.79,809.19l-.312,8.5h14.241V801.459Zm.945-25.706,12.984-6.965v-7.755l-12.7,6.871Zm12.984,9.28v-7.652l-13.3,7.009-.306,8.329Z",
    transform: "translate(8.082 2.039)",
    fill: "#0074bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6963",
    "data-name": "Path 6963",
    d: "M492.532,808.725l-13.975-7.784.009-27.775,12.929,7.2Z",
    transform: "translate(12.214 3.843)",
    fill: "#7c797a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M492.486,809.19l.312,8.5h-14.24V801.459Zm-.945-25.706-12.984-6.965v-7.755l12.7,6.871Zm-12.984,9.28v-7.652l13.3,7.009.306,8.329Z",
    transform: "translate(12.214 2.039)",
    fill: "#0a2a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(448.763 763.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M533.061,808.51v-3.045H520.067v3.045h4.518v7.676h3.958V808.51Zm-14,7.676v-3.044h-8.2v-.955h6.161V809.38H510.86v-.87h8.083v-3.045H506.9v10.721Zm-14.118,0V805.465h-3.97v5.179l-5.081-5.179h-3.914v10.721h3.956v-5.641l5.094,5.641Zm-14.019,0v-.111l-3.241-3.045h1.235a1.264,1.264,0,0,0,1.332-1.376v-4.77a1.3,1.3,0,0,0-1.332-1.418H477.869v10.721h3.958V808.37h4.462v2.161h-3.845v1.712l3.956,3.944Zm-18.972-2.9h-5.052v-4.911h5.052Zm3.958,1.488v-7.886a1.271,1.271,0,0,0-1.306-1.418H464.243a1.27,1.27,0,0,0-1.306,1.418v7.886a1.27,1.27,0,0,0,1.306,1.417H474.6a1.271,1.271,0,0,0,1.306-1.417m-14.146-6.259v-3.045h-13v3.045h4.519v7.676h3.958V808.51Z",
    transform: "translate(-448.763 -746.707)",
    fill: "#605d5d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713",
    transform: "translate(448.763 770.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 2.019,
    cy: 2.019,
    r: 2.019,
    transform: "translate(81.447 58.482)",
    fill: "none",
    stroke: "#605d5d",
    strokeMiterlimit: 10,
    strokeWidth: 0.261
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(448.763 763.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M507.76,811.212v.7h.584a.614.614,0,0,0,.26-.042.291.291,0,0,0,.154-.292.326.326,0,0,0-.148-.316.527.527,0,0,0-.251-.047Zm1.119-.383a.643.643,0,0,1,.243.182.761.761,0,0,1,.13.219.69.69,0,0,1,.049.272.76.76,0,0,1-.095.362.516.516,0,0,1-.306.252.5.5,0,0,1,.254.2.862.862,0,0,1,.075.406v.173a1.291,1.291,0,0,0,.014.241.22.22,0,0,0,.1.148v.065h-.6c-.017-.058-.028-.1-.035-.14a1.285,1.285,0,0,1-.024-.223l0-.241a.492.492,0,0,0-.085-.33.441.441,0,0,0-.309-.082h-.53v1.015h-.529v-2.591h1.239a1.111,1.111,0,0,1,.409.066",
    transform: "translate(-424.794 -744.535)",
    fill: "#605d5d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornLogoDark);
export default __webpack_public_path__ + "static/media/torn-logo-dark.ca0c307f0cfbbb765fd71a98fc58e5b7.svg";
export { ForwardRef as ReactComponent };